/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationRecordValue } from './EvaluationRecordValue';
import {
    EvaluationRecordValueFromJSON,
    EvaluationRecordValueFromJSONTyped,
    EvaluationRecordValueToJSON,
} from './EvaluationRecordValue';

/**
 * 
 * @export
 * @interface EvaluationRecordsResponse
 */
export interface EvaluationRecordsResponse {
    /**
     * Null when no further values remain
     * @type {string}
     * @memberof EvaluationRecordsResponse
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<EvaluationRecordValue>}
     * @memberof EvaluationRecordsResponse
     */
    records: Array<EvaluationRecordValue>;
}

/**
 * Check if a given object implements the EvaluationRecordsResponse interface.
 */
export function instanceOfEvaluationRecordsResponse(value: object): value is EvaluationRecordsResponse {
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function EvaluationRecordsResponseFromJSON(json: any): EvaluationRecordsResponse {
    return EvaluationRecordsResponseFromJSONTyped(json, false);
}

export function EvaluationRecordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationRecordsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'records': ((json['records'] as Array<any>).map(EvaluationRecordValueFromJSON)),
    };
}

export function EvaluationRecordsResponseToJSON(value?: EvaluationRecordsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nextToken': value['nextToken'],
        'records': ((value['records'] as Array<any>).map(EvaluationRecordValueToJSON)),
    };
}

